var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"text-omission"},[_c('span',{ref:"filename",staticClass:"filename",attrs:{"title":_vm.fileName}},[_vm._v("\n    "+_vm._s(_vm.newFileName ? _vm.newFileName : _vm.fileName)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8fe15e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextOmission/index.vue
// module id = null
// module chunks = 